<template>
    <b-tabs pills>
        <b-tab @click="handleOnChangeTab(tabExcerciseDevivered)" title="Bài tập/ bài kiểm tra đang giao"
            :active="tabActive == tabExcerciseDevivered">
            <TabExcerciseAssign v-if="tabActive == tabExcerciseDevivered" />
        </b-tab>
        <b-tab @click="handleOnChangeTab(tabExcerciseNotScore)" title="Bài tập/ bài kiểm tra chưa chấm"
            :active="tabActive == tabExcerciseNotScore">
            <TabExcerciseNotScore v-if="tabActive == tabExcerciseNotScore" />
        </b-tab>
        <b-tab @click="handleOnChangeTab(tabExcerciseWarehouse)" title="Kho bài tập/ bài kiểm tra"
            :active="tabActive == tabExcerciseWarehouse">
            <TabExcerciseWarehouse v-if="tabActive == tabExcerciseWarehouse" />
        </b-tab>
        <b-tab @click="handleOnChangeTab(tabExcercisebank)" title="Ngân hàng đề"
            :active="tabActive == tabExcercisebank">
            <TabExcerciseBank v-if="tabActive == tabExcercisebank" />
        </b-tab>
    </b-tabs>
</template>
<script>
import TabExcerciseAssign from './../excercise_component/TabExcerciseAssign'
import TabExcerciseNotScore from './../excercise_component/TabExcerciseNotScore'
import TabExcerciseWarehouse from './../excercise_component/TabExcerciseWarehouse'
import TabExcerciseBank from './../excercise_component/TabExcerciseBank'
export default {
    components: {
        TabExcerciseAssign,
        TabExcerciseNotScore,
        TabExcerciseWarehouse,
        TabExcerciseBank
    },
    data() {
        return {
            tabActive: 1,
            tabExcerciseDevivered: 1,
            tabExcerciseNotScore: 2,
            tabExcerciseWarehouse: 3,
            tabExcercisebank: 4,
        }
    },
    methods: {
        handleOnChangeTab(tab) {
            this.tabActive = tab
        }
    }
}
</script>